import React, { useState, useContext, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Nav,
  Modal,
  NavDropdown,
} from "react-bootstrap";
import { FiMapPin } from "react-icons/fi";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaHome,
  FaShoppingBag,
  FaInfoCircle,
  FaShoppingCart,
  FaPhoneAlt,
} from "react-icons/fa";
import { BsWhatsapp, BsPlus, BsDash } from "react-icons/bs";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { store } from "../Home/Pages/Store/Store.js";
import PostApiCall from "../helper/PostAPI.js";
import { useCart } from "../Home/Cart";
import logo from "../../../assets/images/logo-new.png";
import "./Header.css";
import Notiflix from "notiflix";
import { newstore } from "../Home/Pages/Store/newStore.js";
import Dropdown from "react-bootstrap/Dropdown";
import { FaCircleUser } from "react-icons/fa6";
import { NewLoginModal } from "../../NewLoginModal.js";
import ChangePassword from "../../ChangePassword.js";
import LogoutModal from "../../LogoutModal.js";

function Header({ navRef }) {
  const {
    setcart,
    setcartamount,
    loggedIn,
    setLoggedIn,
    setCartItems,
    cartItems,
    loginModalStatus,
    setLoginModalStatus,
    modalSide,
    setModalSide,
  } = useContext(newstore);
  const [openChangePwd, setOpenChangePwd] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [show, setShow] = useState(false);

  const { getTotalItems, updateCartItem } = useCart();
  const [showCart, setShowCart] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const { setSearchText } = useContext(store);
  const [products, setProducts] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const handleChangeModalSide = (e) => {
    setModalSide(e);
  };

  const handleToggleModal = () => {
    setModalSide("Log");
    setLoginModalStatus(false);
  };

  const imgpath = "http://localhost:5000";

  useEffect(() => {
    getCustomerDetails();

    const handleScroll = () => {
      if (location.pathname === "/shop") {
        setScrolled(window.scrollY > 100);
      }
    };

    if (location.pathname === "/shop") {
      window.addEventListener("scroll", handleScroll);
    }
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location]);
  const getCustomerDetails = () => {
    var loginDetails = JSON.parse(localStorage.getItem("CustomerData"));
    if (loginDetails !== null) {
      setLoggedIn(true);
    }
  };
  useEffect(() => {
    PostApiCall.postRequest(
      {
        catCount: "*",
      },
      "GetProductVertical",
    ).then((results) =>
      results?.json().then((obj1) => {
        if (results.status === 200 || results.status === 201) {
          setCategoryList(
            obj1.data.filter((dat) => dat.fld_status === "Active"),
          );
        }
      }),
    );
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClose = () => setShowCart(false);
  const handleShow = () => setShowCart(true);

  const handleRazorpayPayment = () => {
    const totalAmount = cartItems.reduce(
      (total, item) => total + item.quantity * item.price,
      0,
    );
    const options = {
      key: "YOUR_TEST_KEY_ID",
      amount: totalAmount * 100,
      currency: "INR",
      name: "Ariha Foods",
      description: "Order Payment",
      image: "/logo.png",
      handler: function (response) {
        alert(
          "Payment successful! Payment ID: " + response.razorpay_payment_id,
        );
      },
      prefill: { name: customerName, contact: customerPhone },
      theme: { color: "#6E9556" },
    };
    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  // useEffect(() => {
  //   PostApiCall.postRequest(
  //     {
  //       categoryid: null,
  //       orderid: 0,
  //     },
  //     "getFoodMenuOrder"
  //   ).then((results) =>
  //     results.json().then((data) => {
  //       if (results.status === 200 || results.status === 201) {
  //         setProducts(data.message);
  //       }
  //     })
  //   );
  // }, []);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    if (value.trim() !== "") {
      const filtered = products.filter(
        (product) =>
          product.FLD_Name?.toLowerCase().includes(value.toLowerCase()) ||
          product.FLD_Category?.toLowerCase().includes(value.toLowerCase()) ||
          product.search_field?.toLowerCase().includes(value.toLowerCase()),
      );
      setSuggestions(filtered);
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  // const handleSuggestionClick = (item) => {
  //   setSearchText(item.FLD_Name);
  //   setSearchInput(item.FLD_Name);
  //   setShowSuggestions(false);
  //   navigate(`/shop#${item.FLD_Item_ID}`);
  // };

  useEffect(() => {
    getCartdetails();
  }, []);
  const onLogout = () => {
    if (localStorage.getItem("CustomerData") !== null) {
      localStorage.removeItem("CustomerData");
      localStorage.removeItem("OrderData");
      localStorage.clear();
      setcart(0);
      setcartamount(0);
      navigate("/");
      setCartItems([]);
      handleToggleLogout();
      Notiflix.Notify.Success("Log out successfully.");
      setLoggedIn(false);
      Notiflix.Loading.Remove();
    } else {
      Notiflix.Notify.Failure("Something went wrong");
    }
  };

  const getCartdetails = () => {
    Notiflix.Loading.Circle();
    var login = localStorage.getItem("CustomerData");
    var logindetails = JSON.parse(login);
    var Order = localStorage.getItem("OrderData");
    var Orderdetails = JSON.parse(Order);
    PostApiCall.postRequest(
      {
        orderid:
          localStorage.getItem("OrderData") == null
            ? null
            : Orderdetails[0].order_id,
        id:
          localStorage.getItem("CustomerData") == null
            ? null
            : logindetails[0].fld_customerid,
      },
      "GetCartWebsite",
    )
      .then((res) => res.json())
      .then((res1) => {
        // console.log(res1);
        if (res1.data) {
          setCartItems(res1.data);
          Notiflix.Loading.Remove();
          setcart(res1?.data.reduce((a, v) => (a = a + v.fld_quantity), 0));
          // setcartamount(res1.data[0]?.fld_cart_amount_preview);
        }
      });
  };

  const changePssword = () => {
    setOpenChangePwd(true);
  };

  const [canLogout, setCanLogout] = useState(false);

  // change password specific functions
  const handleTogglePwdModal = () => {
    setOpenChangePwd(false);
  };

  const handleToggleLogout = () => {
    setCanLogout(false);
  };

  return (
    <>
      <LogoutModal
        show={canLogout}
        onHide={handleToggleLogout}
        onLogout={onLogout}
      />
      <ChangePassword
        isOpen={openChangePwd}
        handdleToggleModal={handleTogglePwdModal}
      />
      <div
        style={{
          position: `${
            location.pathname === "/shop" && scrolled ? "absolute" : "fixed"
          }`,
          top: 0,
          width: "100%",
          zIndex: 1025,
          backgroundColor: "#fff",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Top Info Bar */}
        {!isMobile && (
          <div className="py-2 shadow-sm border-bottom bg-white">
            <Container>
              <Row className="align-items-center justify-content-between">
                <div className="desktop-only d-flex flex-column flex-md-row justify-content-between align-items-center">
                  <Col
                    xs={12}
                    md="auto"
                    className="text-center text-md-start mb-2 mb-md-0"
                  >
                    <FiMapPin size={20} className="me-2" />
                    MIG 156B, 6th Main Rd, West, Nolambur, Mogappair, Chennai,
                    Tamil Nadu, 600037
                  </Col>
                  <Col
                    xs={12}
                    md="auto"
                    className="d-flex justify-content-center justify-content-md-end"
                  >
                    <div className="social d-flex">
                      <a
                        href="https://www.facebook.com/arihafoods/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="me-3 text-dark"
                      >
                        <FaFacebookF size={20} />
                      </a>
                      <a
                        href="https://www.instagram.com/ariha_foods/?hl=en"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="me-3 text-dark"
                      >
                        <FaInstagram size={20} />
                      </a>
                      <a
                        href="https://in.linkedin.com/company/arihafoods-private-limited"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="me-3 text-dark"
                      >
                        <FaLinkedinIn size={20} />
                      </a>
                      <a
                        href="https://www.youtube.com/@arihafoods"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-dark"
                      >
                        <FaYoutube size={20} />
                      </a>
                    </div>
                  </Col>
                </div>
              </Row>
            </Container>
          </div>
        )}

        {/* Main Header Row */}
        <Container fluid className="py-2 shadow-search">
          <Row className="align-items-center">
            <Col>
              <div className="d-flex align-items-center justify-content-between w-100">
                {/* Logo (left) */}
                <a href="/" className="me-4">
                  <img src={logo} alt="logo" width="70px" />
                </a>

                {/* Navigation (center, flex-grow) */}
                <Nav className="flex-row mx-auto d-none d-md-flex">
                  <Nav.Link href="/" className="text-dark fw-bold mx-3">
                    Home
                  </Nav.Link>
                  <NavDropdown
                    id="offcanvasNavbarDropdown-expand-sm"
                    show={show}
                    onMouseEnter={() => setShow(true)}
                    onMouseLeave={() => setShow(false)}
                    title={
                      <Link
                        to="/shop"
                        className="text-dark fw-bold mx-3 text-decoration-none"
                        role="button"
                      >
                        Shop
                      </Link>
                    }
                    renderMenuOnMount
                  >
                    {categoryList?.map((items) => (
                      <NavDropdown.Item
                        key={items?.fld_verticlename}
                        as={Link}
                        to={`/category/${items?.fld_route}`}
                        className="allshopnow"
                        onClick={() => setShow(false)} // close on click
                      >
                        {items?.fld_verticlename}
                      </NavDropdown.Item>
                    ))}
                  </NavDropdown>
                  {/* <Nav.Link href="/shop" className="text-dark fw-bold mx-3">
                    Shop
                  </Nav.Link> */}
                  <Nav.Link href="/about" className="text-dark fw-bold mx-3">
                    About Us
                  </Nav.Link>
                  <Nav.Link href="/contact" className="text-dark fw-bold mx-3">
                    Contact Us
                  </Nav.Link>
                  {/* <Nav.Link
                    href="/franchise"
                    className="text-dark fw-bold mx-3"
                  >
                    Franchise
                  </Nav.Link> */}
                </Nav>
                <div className="d-flex gap-4">
                  <div className="user-profile-menu">
                    <Dropdown>
                      <Dropdown.Toggle variant="success" id="dropdown-basic">
                        <div>
                          <FaCircleUser size={24} />
                        </div>
                      </Dropdown.Toggle>

                      {loggedIn ? (
                        <Dropdown.Menu>
                          <Dropdown.Item href="/customer-profile">
                            Profile
                          </Dropdown.Item>
                          <Dropdown.Item onClick={changePssword}>
                            Change Password
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => setCanLogout(true)}>
                            Logout
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      ) : (
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => {
                              setModalSide("Log");
                              setLoginModalStatus(true);
                            }}
                          >
                            Log In
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => {
                              setModalSide("Reg");
                              setLoginModalStatus(true);
                            }}
                          >
                            Sign Up
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      )}
                    </Dropdown>
                  </div>
                </div>

                {/* <Form
                  className="d-flex align-items-center"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div style={{ position: "relative", width: "100%" }}>
                    <Form.Control
                      type="search"
                      placeholder="Search the products..."
                      value={searchInput}
                      onChange={handleInputChange}
                      onFocus={() => {
                        if (
                          searchInput.trim() !== "" &&
                          suggestions.length > 0
                        ) {
                          setShowSuggestions(true);
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          setSearchText(searchInput);
                          setShowSuggestions(false);
                          navigate("/shop");
                        }
                      }}
                    />
                    {showSuggestions && suggestions.length > 0 && (
                      <div className="search-suggestions-dropdown">
                        {suggestions.slice(0, 6).map((item) => (
                          <div
                            key={item.FLD_Item_ID}
                            className="suggestion-item"
                            onClick={() => handleSuggestionClick(item)}
                          >
                            <img
                              src={item.FLD_Image}
                              alt={item.FLD_Name}
                              className="suggestion-img"
                            />
                            <div>
                              <div className="suggestion-title">
                                {item.FLD_Name}
                              </div>
                              <div className="suggestion-sub">
                                {item.Category_name || "Uncategorized"}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  {window.innerWidth > 768 && (
                    <Button
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        border: "none",
                        borderRadius: "8px",
                        padding: "0 20px",
                        marginLeft: "8px",
                      }}
                      onClick={() => {
                        setSearchText(searchInput);
                        navigate("/shop");
                        setShowSuggestions(false);
                      }}
                    >
                      Search
                    </Button>
                  )}
                </Form> */}
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Cart Modal */}
      <Modal show={showCart} onHide={handleClose} size="lg">
        <Modal.Body
          style={{
            backgroundColor: "#6E9556",
            color: "white",
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
          }}
        >
          <Button
            variant="light"
            size="sm"
            onClick={handleClose}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              padding: 0,
            }}
          >
            &times;
          </Button>

          <div className="text-center mb-3">
            <BsWhatsapp
              size={24}
              className="bg-white text-success rounded-circle p-1"
            />
            <h5 className="mt-2 mb-0">Shopping Cart</h5>
            <hr className="border-white opacity-100" />
          </div>

          {cartItems.map((item) => (
            <div
              key={item._id}
              className="d-flex align-items-center justify-content-between mb-3"
              style={{ gap: "10px" }}
            >
              <img
                src={`${imgpath}${item.product_image}`}
                alt={item.name}
                className="rounded"
                style={{ width: "50px", height: "50px", objectFit: "cover" }}
              />
              <div className="flex-grow-1 ms-2">
                <div style={{ fontSize: "14px", fontWeight: 500 }}>
                  {item.name}
                </div>
              </div>
              <div className="d-flex align-items-center">
                <Button
                  size="sm"
                  variant="light"
                  className="text-dark p-1"
                  onClick={() =>
                    updateCartItem(
                      item._id,
                      "quantity",
                      Math.max(1, item.quantity - 1),
                    )
                  }
                >
                  <BsDash />
                </Button>
                <span className="mx-2">{item.quantity}</span>
                <Button
                  size="sm"
                  variant="light"
                  className="text-dark p-1"
                  onClick={() =>
                    updateCartItem(item._id, "quantity", item.quantity + 1)
                  }
                >
                  <BsPlus />
                </Button>
              </div>
              <div className="fw-bold text-end" style={{ minWidth: "60px" }}>
                ₹{item.price}
              </div>
            </div>
          ))}

          <div className="d-flex justify-content-between align-items-center mt-4">
            <img src={logo} alt="Ariha Foods" style={{ height: "30px" }} />
            <div className="fw-bold fs-5">
              Total ₹
              {cartItems.reduce(
                (total, item) => total + item.quantity * item.price,
                0,
              )}
            </div>
          </div>

          <Row className="mt-2" id="formrazor">
            <Col md={6} sm={12}>
              <Form.Group className="mb-3">
                <Form.Label style={{ color: "white" }}>
                  Customer Name
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your name"
                  value={customerName}
                  onChange={(e) => setCustomerName(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={6} sm={12}>
              <Form.Group className="mb-3">
                <Form.Label style={{ color: "white" }}>Phone Number</Form.Label>
                <Form.Control
                  type="tel"
                  placeholder="Enter your phone number"
                  value={customerPhone}
                  onChange={(e) => setCustomerPhone(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <p
            className="mt-2 small"
            onClick={() => {
              const messageLines = cartItems.map(
                (item, index) =>
                  `${index + 1}. ${item.name} × ${item.quantity} = ₹${
                    item.quantity * item.price
                  }`,
              );
              const grandTotal = cartItems.reduce(
                (total, item) => total + item.quantity * item.price,
                0,
              );
              const finalMessage =
                `Welcome to Ariha Foods\n\n` +
                `Customer Name: ${customerName}\n` +
                `Phone Number: ${customerPhone}\n\n` +
                `Order Details:\n${messageLines.join("\n")}\n\n` +
                `Grand Total: ₹${grandTotal}`;
              const whatsappURL = `https://wa.me/919047373960?text=${encodeURIComponent(
                finalMessage,
              )}`;
              window.open(whatsappURL, "_blank");
            }}
          >
            <strong>Note:</strong> Place your orders through WhatsApp{" "}
            <BsWhatsapp />
          </p>
        </Modal.Body>

        <Modal.Footer
          style={{
            backgroundColor: "#6E9556",
            borderTop: "none",
            borderBottomLeftRadius: "20px",
            borderBottomRightRadius: "20px",
          }}
        >
          <Button
            variant="light"
            className="w-100 fw-bold text-dark rounded-pill"
            onClick={handleRazorpayPayment}
          >
            ORDER NOW
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Mobile Bottom Navigation */}

      <div
        className="d-md-none bg-white border-top shadow-sm"
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          width: "100%",
          zIndex: 1050,
        }}
      >
        <Nav className="d-flex justify-content-around">
          <Nav.Link href="/" className="navbar-link">
            <div className="navbar-icon-text">
              <FaHome className="navbar-icon" />
              <div className="navbar-text">Home</div>
            </div>
          </Nav.Link>

          <Nav.Link href="/shop" className="navbar-link">
            <div className="navbar-icon-text">
              <FaShoppingBag className="navbar-icon" />
              <div className="navbar-text">Shop</div>
            </div>
          </Nav.Link>
          <Nav.Link href="/cart" className="navbar-link ">
            <div className="navbar-icon-text">
              <div className="card-items d-flex d-md-none align-items-center justify-content-between position-relative">
                <FaShoppingCart className="navbar-icon" />
                <span className="cart-icon bg-warning text-dark rounded-circle">
                  {cartItems.length}
                </span>
              </div>
              <div className="navbar-text">Cart</div>
            </div>
          </Nav.Link>

          <Nav.Link href="/contact" className="navbar-link">
            <div className="navbar-icon-text">
              <FaPhoneAlt className="navbar-icon" />
              <div className="navbar-text">Contact</div>
            </div>
          </Nav.Link>
          <Nav.Link href="/about" className="navbar-link">
            <div className="navbar-icon-text">
              <FaInfoCircle className="navbar-icon" />
              <div className="navbar-text">About Us</div>
            </div>
          </Nav.Link>
        </Nav>
      </div>
      <NewLoginModal
        isOpen={loginModalStatus}
        handleToggleModal={handleToggleModal}
        modalSide={modalSide}
        handleChangeModalSide={handleChangeModalSide}
      />
    </>
  );
}

export default Header;
